export interface FeeBreakdownItem {
  feeId: number;

  /* The amount of money for this order associated with this fee. */
  amount: number;

  /* At what level this fee is applied. Only makes sense with value type AMOUNT as percentage fees will be the same regardless of weather they are applied at transaction or token level */
  applicationLevel: ApplicationLevel;

  /* The name of this fee */
  name: string;

  /* The reason this fee is applied. Allows special UI to show up explaining each fee. */
  reason: Reason;

  /* At what level this fee is applied. Only makes sense with value type AMOUNT as percentage fees will be the same regardless of weather they are applied at transaction or token level */
  responsibilityType: ResponsibilityType;

  /* The value associated with this fee. Should be used alongside valueType. For example for a 10% fee, the value will be 10 and the value type will be PERCENT. */
  value: number;

  /* The type of value. Used to distinguish between percentage fees and fixed amount fees */
  valueType: ValueType;

  nameLong: string;
  includedInBase: boolean;
  externalTax: boolean;
}

export enum ValueType {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
  PROFIT_PERCENTAGE = 'PROFIT_PERCENTAGE',
  STEPPED = 'STEPPED',
  TBD = 'TBD',
}

export enum ApplicationLevel {
  TOKEN = 'TOKEN',
  TRANSACTION = 'TRANSACTION',
  PREVIOUS_FEE = 'PREVIOUS_FEE',
  TOKEN_PROFIT = 'TOKEN_PROFIT',
}

export enum ResponsibilityType {
  CLIENT = 'CLIENT',
  BUYER = 'BUYER',
  SELLER = 'SELLER',
}

export enum Reason {
  PAYMENT = 'PAYMENT',
  PROFIT_SHARE = 'PROFIT_SHARE',
  TAX = 'TAX',
  YOOP = 'YOOP',
}

export enum SubReason {
  STATE_TAX = 'STATE_TAX',
  FEDERAL_TAX = 'FEDERAL_TAX',
}

export enum BreakdownDisplayOption {
  ALL = 'ALL',
  EMAIL = 'EMAIL',
}



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/client/src/model/fee-breakdown-item.ts